export default __webpack_public_path__ + "static/media/9fd6265a62802f730851f9c72cd691b6.jpg";